export enum SmartTeamsPermission {
  CompanyCreate = 'CompanyCreate',
  CompanyRead = 'CompanyRead',
  CompanyUpdate = 'CompanyUpdate',
  CompanyDelete = 'CompanyDelete',
  CompanyView = 'CompanyView',

  CustomerCreate = 'CustomerCreate',
  CustomerRead = 'CustomerRead',
  CustomerUpdate = 'CustomerUpdate',
  CustomerDelete = 'CustomerDelete',
  CustomerView = 'CustomerView',

  UserManage = 'UserManage',
  'Users.Impersonate' = 'Users.Impersonate',
  'Users.ChangePassword' = 'Users.ChangePassword',

  FECreate = 'FECreate',
  FERead = 'FERead',
  FEUpdate = 'FEUpdate',
  FEDelete = 'FEDelete',
  FEView = 'FEView',
  FEImportExportAdmin = 'FEImportExportAdmin',

  AvailabilityCreate = 'AvailabilityCreate',
  AvailabilityRead = 'AvailabilityRead',
  AvailabilityUpdate = 'AvailabilityUpdate',
  AvailabilityDelete = 'AvailabilityDelete',
  AvailabilityView = 'AvailabilityView',

  CalendarView = 'CalendarView',

  FileManage = 'FileManage',

  APIAccess = 'APIAccess',
}

export const SmartTeamsRoleNames = {
  NSC_ADMIN: 'NSC Admin',
  PARTNER_MANAGER: 'Partner Manager',
  NSC_AGENT: 'NSC Agent',
} as const;

export const COMPANY_SCOPABLE_PERMISSIONS = [
  SmartTeamsPermission.FECreate,
  SmartTeamsPermission.FERead,
  SmartTeamsPermission.FEUpdate,
  SmartTeamsPermission.FEDelete,
  SmartTeamsPermission.AvailabilityCreate,
  SmartTeamsPermission.AvailabilityRead,
  SmartTeamsPermission.AvailabilityUpdate,
  SmartTeamsPermission.AvailabilityDelete,
] as const;
